// Ebon activation types
export const EBON_ACTIVATION_TYPE_ONLINE = 'ONLINE';
export const EBON_ACTIVATION_TYPE_OFFLINE = 'OFFLINE';
export const EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE = 'ONLINE_AND_OFFLINE';

// Ebon code types
export const EBON_TYPE_DOWNLOAD_CODE = 'DOWNLOAD_CODE';
export const EBON_TYPE_LINK_CODE = 'LINK_CODE';
export const EBON_TYPE_PRE_DOWNLOADED_LINK = 'PRE_DOWNLOADED_LINK';

// Enterprise card
export const ENTERPRISE_CARD_ENABLED = true;
export const ENTERPRISE_CARD_NAME = 'Malicéa e-card';
export const ENTERPRISE_CARD_PARTNER_EBC_ID = 113;

// Ebon instant discount
export const HAS_INSTANT_DISCOUNT = false;

// Ebon parity
export const USE_PARITY = false;
export const COIN_NAME = '';

// Free facial value proposals: candidates when the API returns no facial value (same as Plebicard V2)
export const FREE_FACIAL_DEFAULT_VALUES = [10, 20, 30, 50, 100, 150, 200, 300, 400, 500];
export const FREE_FACIAL_DEFAULT_PROPOSALS_COUNT = 4;
export const FREE_FACIAL_PROPOSAL_QUANTITY = 20;
export const FREE_FACIAL_PROPOSAL_EXPIRATION_DATE = 32503680000000;



// WEBPACK FOOTER //
// ./src/constants/ebon.js